module.exports = __webpack_public_path__ + "static/media/hm-testimonial-3.8a226ce6.png";